<script lang="ts">
	import ZoiBackground from '$assets/launchpad/zoi-background.webp';
	import ZoiBig from '$assets/launchpad/zoi-big.webp';
	import ZoiSmall from '$assets/launchpad/zoi-small.webp';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import { addNotification } from '$lib/components/notifications/notifications';
	import { trackLaunchpadClick } from '$lib/services/tracking/googleAnalytics/launchpad';
	import { getSearchParamsStore, gotoWithParams } from '$lib/services/urls/searchParams';
	import * as m from '$paraglide/messages';

	const searchParams = getSearchParamsStore();

	const beforeElementClasses = 'before:absolute before:bg-[size:contain] before:w-84px before:h-84px before:left--54% before:top-0';
	const afterElementClasses = 'after:absolute after:bg-[size:contain] after:w-136px after:h-130px after:left-100%';

	function handleZoiDiscoverClick() {
		trackLaunchpadClick('launchpad_zoi_discover');
		gotoWithParams('/routes', { ...$searchParams });
		addNotification(m.launchpad__zois_notification());
	}
</script>

<section
	class="launchpad-zois grid w-full min-h-130px pt-4 overflow-hidden"
	style="--zoi-before-background: url({ZoiSmall}); --zoi-after-background: url({ZoiBig}); --zoi-background: url({ZoiBackground});">
	<div class="relative max-w-45 flex justify-center flex-wrap items-center py-6 px-4 {beforeElementClasses} {afterElementClasses}">
		<h3 class="text-center text-balance uppercase text-sm text-coloredneutral-soft font-600 my-0 mb-2 font-smooth">{m.launchpad__zois_title()}</h3>
		<Button
			variant="filled"
			color="light"
			size="md"
			icon="directions"
			iconPosition="right"
			text={m.launchpad__zois_cta_label()}
			class="shadow-smooth-block"
			onclick={handleZoiDiscoverClick}
		/>
	</div>
</section>

<style>
	.launchpad-zois {
		grid-template-areas: "item";
		place-content: center;
	}
	.launchpad-zois::before {
		background: radial-gradient(44.91% 87.01% at 50% 39.98%, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%),
			linear-gradient(178.37deg, rgba(255, 255, 255, 0) 57.45%, #FFFFFF 96.16%),
			linear-gradient(358.62deg, rgba(255, 255, 255, 0) 50.43%, #FFFFFF 96.31%),
			var(--zoi-background) center / cover no-repeat;
		mix-blend-mode: darken;
		content: '';
		width: 100%;
		height: 160px;
		grid-area: item;
		position: absolute;
	}
	.launchpad-zois > div {
		grid-area: item;
		isolation: isolate;
	}

	.launchpad-zois > div::before,
	.launchpad-zois > div::after {
		content: '';
		background-repeat: no-repeat;
		background-image: var(--zoi-before-background);
	}
	.launchpad-zois > div::after {
		background-image: var(--zoi-after-background);
	}
</style>
